import { Coordinates } from "../types";

export const leiria: Coordinates = { latitude: 39.7436, longitude: -8.8071 };
